import React, { useContext } from "react";
import TableStatisticalUI from "./TableStatisticalUI";
import TableSOPUI from "./TableSOPUI";
import FcstAccuracy from "./Table/FcstAccuracy";
import { AppContext } from "../contexts/AppContext";

export default function TabsComponent({ tabs, selectedItemName, refreshCount, onRefreshComplete, isEditEnabled, sopData, selectedType, isSingleModel }) {
  const { activeTab, setActiveTab } = useContext(AppContext);
  return (
    <div data-testid="tabs-container" className="tabs-container h-full">
      {/* Dynamic Tabs Header */}
      <div className="tabs-header _second_tabs" style={{ borderBottom: '1px solid #E4E4E7', marginBottom: '12px' }}>
        <div className="_left_tabs groups" style={{ display: 'flex', gap: '0' }}>
          {tabs.map((tab) => (
            <button
              key={tab.id}
              data-testid={`tab-${tab.label.toLowerCase().replace(/\s+/g, '-')}`}
              className={`${activeTab === tab.id ? "" : ""}`}
              onClick={() => setActiveTab(tab.id)}
              style={{
                padding: '8px 16px',
                fontSize: '0.72rem',
                fontWeight: activeTab === tab.id ? 700 : 500,
                textTransform: 'uppercase',
                letterSpacing: '0.1em',
                color: activeTab === tab.id ? '#09090B' : '#A1A1AA',
                borderBottom: activeTab === tab.id ? '2px solid #002FA7' : '2px solid transparent',
                background: 'transparent',
                border: 'none',
                borderBottomWidth: 2,
                borderBottomStyle: 'solid',
                borderBottomColor: activeTab === tab.id ? '#002FA7' : 'transparent',
                cursor: 'pointer',
                fontFamily: "'IBM Plex Sans', sans-serif",
                transition: 'color 0.15s ease, border-color 0.15s ease'
              }}
            >
              {tab.label}
            </button>
          ))}
        </div>

      </div>

      {/* Static Content Section */}
      <div className="tabs-content h-full">
        {activeTab === 0 && <TableStatisticalUI selectedItemName={selectedItemName} refreshCount={refreshCount} onRefreshComplete={onRefreshComplete} isEditEnabled={isEditEnabled} />}
        {activeTab === 1 && <TableSOPUI selectedItemName={selectedItemName} sopData={sopData} selectedType={selectedType} isSingleModel={isSingleModel} />}
        {activeTab === 2 && <FcstAccuracy selectedItemName={selectedItemName}
          selectedType={selectedType}
          sopData={sopData}
          isSingleModel={isSingleModel} />}

      </div>
    </div>
  );
}
